import { apiPatch } from '@/api/api.ts'
import { IUser } from '@/api/user/getUsers.ts'

export interface IReqUpdateUser {
    name: string
    gender: number
    birthDate: string
    contact: string
    address: string
    addressLatitude: number
    addressLongitude: number
    deviceSerial?: string
    primaryRelation?: string
    primaryContact?: string
    secondaryRelation?: string
    secondaryContact?: string
    tertiaryRelation?: string
    tertiaryContact?: string
    inspectorMemo?: string
    addressDetail?: string
}

export const apiUpdateUser = async (id: number, params: Partial<IReqUpdateUser>) => {
    // undefined/null 값 제거
    const cleanParams: Record<string, any> = {}
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null) {
            cleanParams[key] = value
        }
    }
    return await apiPatch<IUser>(`/protectee/${id}`, cleanParams)
}
